module.exports = __webpack_public_path__ + "static/media/successfull_payment.354b9728.gif";